<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import config from "../../../config/config";
import { mapGetters, mapActions } from "vuex";
//import pagination from "laravel-vue-pagination";
import { error_message, success_message } from "../../../state/helpers";

/**
 * Starter component
 */
export default {
  page: {
    title: "Version",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  computed: mapGetters("version", [
    "getAllVersion",
    "loading",
    "versionCount",
    "pagination",
  ]),
  data() {
    return {
      sortBy: "id",
      sortDesc: true,
      pages: [],
      paginations: {},
      limit: 1,
      search: "",
      perPage: 5,
      config: config,
      fields: [
        {
          key: "ios_version",
          label: "IOS Version",
          sortable: true,
        },
        {
          key: "android_version",
          label: "Android Version",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          sortable: false,
        },
      ],
    };
  },
  mounted() {
    this.getVersion(this.page);
  },
  methods: {
    ...mapActions("version", ["getVersions", "deleteVersion"]),
    getVersion(page = 1) {
      var filters = {
        search: this.search,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        perPage: this.perPage,
      };
      this.getVersions(filters);
    },

    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getVersion();
    },
    deleteById(id) {
      if (confirm("Are you sure you want to delete Version")) {
        this.deleteVersion({ id: id }).then((response) => {
          if (response.data.code === 200) {
            success_message(response.data.msg);
            this.getVersion();
          } else {
            error_message(response.data.msg);
          }
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left d-flex align-items-center">
            <div class="avatar-xs mr-3">
              <span
                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
              >
                <i class="bx bx-tag"></i>
              </span>
            </div>
            <h4 class="mb-0 font-size-18">Versions ({{ versionCount }})</h4>
          </div>
          <div class="page-title-right">
            <router-link
              :to="{ name: 'version-add' }"
              class="btn btn-success btn-rounded mr-2 add-btn"
            >
              <i class="mdi mdi-plus mr-1"></i>
              Add Version
            </router-link>
            <a
              :href="config.appurl + 'download-versions-data'"
              class="btn btn-primary btn-md btn-rounded ml-1"
            >
              Download All Data
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 list-table-main">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-2 offset-sm-6">
                <div class="form-group">
                  <div class="date-range-list">
                    <!-- <label>Per Page :</label>
                                        <select class="custom-select" v-model="perPage" @change="searchData()">
                                            <option value="10" selected>10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 table-main-list customer-table table-responsive">
                <b-table
                  :items="getAllVersion || []"
                  :fields="fields"
                  :update:sortBy="sortBy"
                  :update:sortDesc="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :busy="loading"
                  show-empty
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t(" Loading") }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(status)="data">
                    <div
                      v-if="data.item.status == 1"
                      class="badge badge-pill badge-soft-success font-size-12 mt-2"
                    >
                      Active
                    </div>
                    <div
                      v-else
                      class="badge badge-pill badge-soft-danger font-size-12 mt-2"
                    >
                      InActive
                    </div>
                  </template>
                  <template v-slot:cell(action)="data">
                    <router-link
                      :to="{ name: 'version-edit', params: { id: base64(data.item.id) } }"
                      class="btn btn-primary btn-sm btn-rounded"
                      >View
                    </router-link>
                    <button
                      type="submit"
                      class="btn btn-danger btn-sm btn-rounded ml-1"
                      @click="deleteById(base64(data.item.id))"
                    >
                      Delete
                    </button>
                  </template>
                  <template #empty>
                    <p class="text-center">{{ $t("Version not found") }}</p>
                  </template>
                </b-table>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination
                        :data="pagination"
                        :limit="limit"
                        @pagination-change-page="getVersion"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
